import axios from "axios";

// Base URL for API - change this for production
const BASE_URL = "https://customerreports.healthmax.co.ke/backend/api";
 //const BASE_URL = "http://localhost/backend/api";

// Create axios instance
const api = axios.create({
  baseURL: BASE_URL,
  headers: {
  },
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle responses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  login: (credentials) => api.post("/auth.php?action=login", credentials),
};

// Users API
export const usersAPI = {
  getAll: () => api.get("/users.php"),
  create: (userData) => api.post("/users.php?action=register", userData),
  update: (id, userData) => api.put(`/users.php?id=${id}`, userData),
  delete: (id) => api.delete(`/users.php?id=${id}`),
};

// Salespersons API
export const salespersonsAPI = {
  getAll: () => api.get("/salespersons.php"),
  getById: (id) => api.get(`/salespersons.php?id=${id}`),
  create: (salesperson) => api.post("/salespersons.php", salesperson),
  update: (id, salesperson) =>
    api.put(`/salespersons.php?id=${id}`, salesperson),
  delete: (id) => api.delete(`/salespersons.php?id=${id}`),
};

// Counties API
export const countiesAPI = {
  getAll: () => api.get("/counties.php"),
};

// Customers API
export const customersAPI = {
  getAll: (params = {}) => api.get("/customers.php", { params }),
  getById: (id) => api.get(`/customers.php?id=${id}`),
  create: (customer) => api.post("/customers.php", customer),
  update: (id, customer) => api.put(`/customers.php?id=${id}`, customer),
  delete: (id) => api.delete(`/customers.php?id=${id}`),
  getOverdue: (params = {}) =>
    api.get("/customers.php?action=overdue", { params }),
};

// Interactions API
export const interactionsAPI = {
  getAll: () => api.get("/interactions.php"),
  getByCustomer: (customerId) =>
    api.get(`/interactions.php?customer_id=${customerId}`),
  create: (interaction) => api.post("/interactions.php", interaction),
  update: (id, interaction) =>
    api.put(`/interactions.php?id=${id}`, interaction),
  delete: (id) => api.delete(`/interactions.php?id=${id}`),
};

// Orders API
export const ordersAPI = {
  getAll: () => api.get("/orders.php"),
  getByCustomer: (customerId) =>
    api.get(`/orders.php?customer_id=${customerId}`),
  create: (order) => api.post("/orders.php", order),
  update: (id, order) => api.put(`/orders.php?id=${id}`, order),
  delete: (id) => api.delete(`/orders.php?id=${id}`),
};

// Notes API
export const notesAPI = {
  getByCustomer: (customerId) =>
    api.get(`/notes.php?customer_id=${customerId}`),
  create: (note) => api.post("/notes.php", note),
  update: (id, note) => api.put(`/notes.php?id=${id}`, note),
  delete: (id) => api.delete(`/notes.php?id=${id}`),
};

// Notifications API
export const notificationsAPI = {
  getAll: () => api.get("/notifications.php"),
  getUnreadCount: () =>
    api.get("/notifications.php", { params: { action: "unread-count" } }),
  getTodayNotifications: () =>
    api.get("/notifications.php", { params: { action: "today" } }),
  markAsRead: (notificationId) =>
    api.put("/notifications.php", {
      action: "mark-read",
      notification_id: notificationId,
    }),
  markAllAsRead: () =>
    api.put("/notifications.php", { action: "mark-all-read" }),
  delete: (notificationId) =>
    api.delete("/notifications.php", {
      params: { id: notificationId },
    }),
};

// Dashboard API
export const dashboardAPI = {
  getStats: () => api.get("/dashboard.php"),
};

// Utility function to format currency in KSH
export const formatKSH = (amount) => {
  return new Intl.NumberFormat("en-KE", {
    style: "currency",
    currency: "KES",
    minimumFractionDigits: 2,
  }).format(amount);
};


export default api;
